function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export function throttle(callback, delay) {
  var last;
  var timer;
  return function () {
    var context = this;
    var now = +new Date();
    var args = arguments;
    if (last && now < last + delay) {
      // le délai n'est pas écoulé on reset le timer
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        callback.apply(context, args);
      }, delay);
    } else {
      last = now;
      callback.apply(context, args);
    }
  };
}
export function debounce(callback, delay) {
  var timer;
  return function () {
    var args = arguments;
    var context = this;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, delay);
  };
}
export function fetchOrAbort(key, url) {
  var _window$_fetchsAbort$;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3000;
  if (!window._fetchsAbort) {
    window._fetchsAbort = {};
  }
  (_window$_fetchsAbort$ = window._fetchsAbort[key]) === null || _window$_fetchsAbort$ === void 0 || _window$_fetchsAbort$.abort();
  window._fetchsAbort[key] = new AbortController();
  var requestTimeout = new Promise(function (_, reject) {
    return setTimeout(function () {
      return reject(new Error('timeout'));
    }, timeout);
  });
  var request = fetch(url, _objectSpread(_objectSpread({}, options), {}, {
    signal: window._fetchsAbort[key].signal
  }));
  return Promise.race([request, requestTimeout]).then(function (response) {
    delete window._fetchsAbort[key];
    if (!response.ok) throw new Error("HTTP ".concat(response.status));
    return response;
  });
}
export function safeJsonParse(json) {
  var out = null;
  try {
    out = JSON.parse(json);
  } catch (e) {}
  return out;
}
export function safeJsonStringify(obj) {
  var out = '';
  try {
    out = JSON.stringify(obj);
  } catch (e) {}
  return out;
}